import getStore from '../store';
import { mutator } from 'satcheljs';
import { setReadingPaneItemIndex } from '../actions/searchResultStoreActions';

/**
 * Sets the id of the selected search result item to read.
 */
export let setReadingPaneItemIndexMutator = mutator(setReadingPaneItemIndex, item => {
    let store = getStore();
    store.selectedItemId = item.itemIndex;
});
